import { render, staticRenderFns } from "./BorderedCard.vue?vue&type=template&id=f00fe5a8&scoped=true"
import script from "./BorderedCard.vue?vue&type=script&lang=js"
export * from "./BorderedCard.vue?vue&type=script&lang=js"
import style0 from "./BorderedCard.vue?vue&type=style&index=0&id=f00fe5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00fe5a8",
  null
  
)

export default component.exports